import { LoadingState } from "@repo/app-types/client/client";
import type { Contact } from "@repo/app-types/entities/contact";
import { type FC, useEffect, useState } from "react";
import { getAxiosInstanceWithAuth } from "../../api/axiosConfig.js";
import type { InterviewWithContactAndActivities } from "../../app/admin_client_types.js";
import { buildInterviewsWithContactsAndActivities } from "../interviews/interviewsSlice.js";
import {
  TargetingSlideover,
  type TargetingSlideoverProps,
} from "./targetingSlideover.js";

export const TargetingSlideoverContainer: FC<
  Omit<TargetingSlideoverProps, "existingEmptyInterviews" | "loadingState">
> = (props) => {
  const [emptyInterviews, setEmptyInterviews] = useState<
    InterviewWithContactAndActivities[]
  >([]);
  const [loadingState, setLoadingState] = useState<LoadingState>(
    LoadingState.LOADING,
  );

  // Fetch empty interviews on load
  const fetchEmptyInterviews = async () => {
    try {
      const axios = await getAxiosInstanceWithAuth();
      const response = await axios.get(
        `/projects/${props.project.id}/interviews?mode=empty`,
      );
      const { interviews, contacts, activities } = response.data;

      // Build dictionary from array of contacts
      const contactsDictionary = (contacts as Contact[]).reduce<
        Record<string, Contact>
      >((acc, contact) => {
        acc[contact.id] = contact;
        return acc;
      }, {});

      // Build interviewWithContactAndActivities using same logic as our redux state
      const emptyInterviews = buildInterviewsWithContactsAndActivities(
        interviews,
        contactsDictionary,
        {},
        activities,
      );

      setEmptyInterviews(emptyInterviews);

      setLoadingState(LoadingState.LOADED);
    } catch (error: any) {
      setLoadingState(LoadingState.ERROR);
    }
  };

  useEffect(() => {
    fetchEmptyInterviews();
  }, []);

  return (
    <TargetingSlideover
      {...props}
      existingEmptyInterviews={emptyInterviews}
      loadingState={loadingState}
    />
  );
};
